<template>
  <div :class="['r-card']" @click="viewDetails">
    <div class="cover">
      <img class="r-cover-img" :src="info.cover" alt="" />
      <!-- <div class="modal" v-if="info.type === 'software' && !info.isCkecked">
        <div class="button" @click.stop="openApp(info)">{{ $t('resourceCard.openSoftware') }} ></div>
      </div> -->
      <!-- <div class="tip" v-if="info.shareStatus">
        <a-tag>
          {{ statusMap[String(info.shareStatus)] }}
        </a-tag>
      </div> -->
      <span class="type">{{ info.typeName }}</span>
    </div>
    <div class="info">
      <div class="header">
        <a-tooltip placement="top">
          <template slot="title">
            <span>{{ info.name }}</span>
          </template>
          <div class="name ellipsis-single">{{ info.name }}</div>
        </a-tooltip>
        <a-popover placement="bottomRight" v-if="info.shareStatus !== 4">
          <template slot="content">
            <div class="r-card-popover_btns">
              <a-button type="link" @click="resourceEdit">{{ $t('resourceCard.edit') }}</a-button>
              <a-button type="link" @click="handleShareModal">{{ $t('resourceCard.shareResource') }}</a-button>
              <a-button type="link" @click="downloda">{{ $t('resourceCard.download') }}</a-button>
              <a-button type="link" @click="sort">{{ $t('resourceCard.sort') }}</a-button>
              <a-button type="link" @click="delVisible = true">{{ $t('resourceCard.delete') }}</a-button>
            </div>
          </template>
          <a-icon type="ellipsis" @click.stop="" />
        </a-popover>
      </div>
      <div class="create-time">{{ info.createTime }}</div>
    </div>
    <a-checkbox v-show="info.isCkecked" @change="onChange" v-model="info.checked"></a-checkbox>
    <TipModal
      @ok="handleCommon"
      :visible="common.visible"
      @cancel="handleUnCommon"
      :desc="
        `
        <p>${this.$t('resourceCard.confirmShare')}</p>
        <p class='placeholder'>${this.$t('resourceCard.sharePortalTip')}</p>`
      "
    />
    <TipModal
      @ok="remove"
      @cancel="delVisible = false"
      :visible="delVisible"
      :desc="
        `
        <p>${this.$t('resourceCard.confirmDelete')}</p>
        <p class='placeholder'>${this.$t('resourceCard.deleteNoRecover')}</p>`
      "
    />
    <!--分享-->
    <ShareModal ref="ShareModal" @ok="cancel" @cancel="cancel" />
    <Modal :visible.sync="visible" />
    <sort-modal
      :visible="sortModalVisible"
      :currentWeight="currentWeight"
      :resourceId="info.id"
      @success="$emit('ok')"
      @cancel="sortModalVisible = false"
    />
  </div>
</template>

<script>
import cookie from 'js-cookie'
import TipModal from '@/components/tipModal/index.vue'
import ShareModal from './ShareModal.vue'
import Modal from '@/components/XRInfoModal/index'
import { common, unCommon, deleteResource } from '@/api/lesson'
import { saveAs } from 'file-saver'
import SortModal from './SortModel.vue'

export default {
  name: 'PtCard',
  components: {
    TipModal,
    ShareModal,
    Modal,
    SortModal
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      delVisible: false,
      common: {
        flag: false,
        visible: false,
        callback: this.handleCommon
      },
      statusMap: {
        1: '共享中',
        2: '分享中',
        3: '享'
      },
      isStudent: false,
      sortModalVisible: false,
      currentWeight: 1
    }
  },
  methods: {
    viewDetails() {
      if (this.info.isCkecked) return
      const model = this.$route.query.model || 'teacher'
      this.$router.push({
        name: model === 'admin' ? 'teacherResourceDetails' : 'resourcePrivateDetails',
        query: {
          id: this.info.id,
          resType: 3
          // resType: model === 'admin' ? 4 : 3 // type  1课程 2共享资源 3个人资源 4校级资源
        }
      })
    },
    resourceEdit() {
      const model = this.$route.query.model || 'teacher'
      this.$router.push({
        name: model === 'admin' ? 'teacherResourceAdd' : 'resourcePrivateAdd',
        query: { id: this.info.id, model: model }
      })
    },
    handleCommon() {
      common({ ids: [this.info.id] }).then(res => {
        if (res.code !== 200) return
        this.common.visible = false
        this.$message.success(this.$t('resourceCard.shareSuccess'))
        this.$emit('ok')
      })
    },
    handleUnCommon() {
      this.common.visible = false
      if (this.info.shareStatus !== 1 && this.info.shareStatus !== 3) return
      unCommon({ ids: [this.info.id] }).then(res => {
        if (res.code !== 200) return
        this.$message.success(this.$t('resourceCard.cancelShare'))
        this.$emit('ok')
      })
    },
    handleShareModal() {
      this.$refs.ShareModal.showModal(this.info.id)
    },
    handleCommonModal() {
      this.common.visible = true
    },
    downloda() {
      console.log('this.info ----->', this.info)
      if (!this.info.url) return
      this.downloadFile(this.info.url)
      // window.open(this.info.url)
    },
    remove() {
      deleteResource({ id: this.info.id }).then(res => {
        if (res.code !== 200) return
        this.$message.success(this.$t('resourceCard.deleteSuccess'))
        this.$emit('ok')
      })
    },
    cancel() {
      this.$emit('ok')
    },
    openApp(obj) {
      this.checkedItem = obj
      this.Ok(obj)
    },
    Ok(obj) {
      const userType = cookie.getJSON('user_type').join(',')
      const data = {
        data: Object.assign(cookie.getJSON('user_infor'), {
          resId: obj.id,
          token: localStorage.token,
          roles: cookie.getJSON('user_type'),
          type: 'openRes',
          roomId: '',
          source_type: 2, // 1校本 2个人
          school_type: userType.includes('external') ? 2 : 1, // 1校内 2校外
          deviceType: '',
          player_name: '', // 播放器名字
          player_key: '', // 播放器唯一标识符，XR根据这个参数判断打开播放器传什么样的参数
          playerId: ''
        })
      }
      console.log('------->', data)
      console.log('str------->', JSON.stringify(data))
      // 一键打开应用程序
      // 检测用户的设备是否是Windows系统
      if (/windows|win32/i.test(navigator.userAgent)) {
        // 检测用户的浏览器是否能使用universalLink
        let openApp = false
        const userAgent = navigator.userAgent
        // 判断是否 Firefox浏览器
        if (userAgent.indexOf('Firefox') > -1) {
          openApp = true
        }
        // 判断是否 Chrome浏览器
        if (userAgent.indexOf('Chrome') > -1) {
          openApp = true
        }
        // 判断是否 Edge浏览器
        if (userAgent.indexOf('Edg') > -1) {
          openApp = true
        }
        if (openApp) {
          try {
            this.openUriWithInputTimeoutHack(
              process.env.VUE_APP_XR_NAME + '://' + encodeURIComponent(JSON.stringify(data)),
              error => {
                this.visible = true
                // this.$message.error('软件未安装！')
              },
              success => {
                this.visible = false
                this.checkedItem = null
                // console.log('软件已安装！')
              }
            )
          } catch (err) {
            console.log(err)
            this.$message.warning(this.$t('resourceCard.manualOpenSoftware'))
          }
        }
      }
    },
    openUriWithInputTimeoutHack(url, failCb, successCb) {
      const target = document.createElement('input')
      target.style.width = '0'
      target.style.height = '0'
      target.style.position = 'fixed'
      target.style.top = '0'
      target.style.left = '0'
      document.body.appendChild(target)

      target.focus()
      const handler = this.registerEvent(target, 'blur', onBlur)

      function onBlur() {
        successCb && successCb()
        handler.remove()
        clearTimeout(timeout)
        document.body.removeChild(target)
      }

      location.href = url
      console.log('url ----->', url)

      const timeout = setTimeout(function() {
        failCb && failCb()
        handler.remove()
        document.body.removeChild(target)
      }, 1000)
    },
    registerEvent(target, eventType, cb) {
      if (target.addEventListener) {
        target.addEventListener(eventType, cb)
        return {
          remove: function() {
            target.removeEventListener(eventType, cb)
          }
        }
      } else {
        target.attachEvent(eventType, cb)
        return {
          remove: function() {
            target.detachEvent(eventType, cb)
          }
        }
      }
    },
    async downloadFile(fileUrl) {
      try {
        const response = await fetch(fileUrl)
        if (!response.ok) {
          throw new Error(this.$t('resourceCard.networkError'))
        }
        const blob = await response.blob()
        const fileName =
          this.info.name +
          '.' +
          fileUrl
            .split('/')
            .pop()
            .split('.')[1] // 从 URL 中提取文件名
        saveAs(blob, fileName)
      } catch (error) {
        console.error(this.$t('resourceCard.downloadError'), error)
      }
    },
    sort() {
      this.currentWeight = this.info.order || 1
      this.sortModalVisible = true
    },
  },
  mounted() {
    const userType = JSON.parse(cookie.get('user_type')).join(',')
    if (userType.includes('student')) {
      this.isStudent = true
    }
  }
}
</script>

<style lang="less" scoped>
.r-card {
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  .cover {
    position: relative;
    cursor: pointer;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #eeedeb;
    .r-cover-img {
      width: 100%;
      height: 180px;
    }
    .tip {
      position: absolute;
      left: 6px;
      top: 6px;
      /deep/ .ant-tag {
        color: #000;
        background: rgba(238, 238, 238, 0.8);
        border: none;
      }
    }
    .type {
      left: 0;
      top: 8px;
      min-width: 70px;
      height: 23px;
      padding: 0 5px;
      cursor: pointer;
      font-size: 11px;
      font-weight: 400;
      color: #28383b;
      line-height: 23px;
      text-align: center;
      position: absolute;
      border-radius: 0px 4px 4px 0px;
      background: linear-gradient(224deg, #eceff0 0%, #c6c9cd 100%);
    }
    .modal {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: none;
      cursor: pointer;
      border-radius: 6px;
      position: absolute;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.6);
      .button {
        min-width: 80px;
        height: 30px;
        padding: 0 6px;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
        background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%);
        box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
        border-radius: 6px;
      }
    }
    &:hover .modal {
      display: flex;
      z-index: 999;
    }
  }
  .info {
    padding: 0 10px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0px 3px 0px;
      .name {
        width: 80%;
        font-weight: 550;
        font-size: 15px;
        color: #000;
      }
      /deep/ .ant-popover-open {
        cursor: pointer;
        color: #ff9744;
        background: #ffedea;
        border: 1px solid #ff9744;
        box-sizing: border-box;
        border-radius: 2px;
      }
    }
    .create-time {
      color: #000;
      font-size: 12px;
    }
  }
  /deep/ .ant-checkbox-wrapper {
    position: absolute;
    right: 6px;
    top: 3px;
  }
}
@media screen and(min-width: 1700px) and (max-width: 1900px) {
  .r-card .cover .r-cover-img {
    height: 180px;
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px) {
  .r-card .cover .r-cover-img {
    height: 142px;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1500px) {
  .r-card .cover .r-cover-img {
    height: 136px;
  }
}
@media screen and (min-width: 1300px) and (max-width: 1400px) {
  .r-card .cover .r-cover-img {
    height: 122px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px) {
  .r-card .cover .r-cover-img {
    height: 117px;
  }
}
@media screen and (max-width: 1200px) {
  .r-card .cover .r-cover-img {
    height: 103px;
  }
}
</style>
<style lang="less">
.r-card-popover_btns {
  .ant-btn {
    width: 100%;
    display: block;
    padding: 0px;
  }
  .ant-btn-link {
    color: #000;
    &:hover {
      color: #ff9744;
    }
  }
}
</style>
